import axios from 'axios';
import { getCookie } from '../../App';
import { domain } from '../Links/Links';

export function UploadImageOperation(setAuthenticationImage, setRequestStatus) {
    const input = document.createElement('input');
    input.type = 'file';
    input.click();

    input.onchange = (e) => {
        const file = e.target.files[0];
        AuthenticationRequest(file, setAuthenticationImage, setRequestStatus)
    }
}

export async function AuthenticationRequest(file, setAuthenticationImage, setRequestStatus) {

    setRequestStatus(true);

    const formData = new FormData();
    formData.append('image', file);

    const response = await axios.post(domain + '/authentication/', formData, {
        withCredentials: true,
        headers: {
            'X-CSRFToken': getCookie('csrf_token')
        },

        onUploadProgress: (event) => {
            if (!event.total) return;

            const perncet = Math.round((event.loaded * 100) / event.total)

            console.log(perncet)
        }

    })

    if (response.data) {
        setRequestStatus(false);
    }

    setAuthenticationImage(response.data);


    console.log(response.data)

}